"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKEN_LIST_MAX_NAME_LENGTH = exports.TOKEN_LIST_MIN_NAME_LENGTH = void 0;
exports.TOKEN_LIST_MIN_NAME_LENGTH = 3;
exports.TOKEN_LIST_MAX_NAME_LENGTH = 32;
